import { isNull } from "lodash";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import React, { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

// Imported assets
import {
  LockIcon,
  LogoutIcon,
  ProfileIcon,
  SettingsIcon,
} from "../../../assets/icons/svgs/Icons.jsx";

// Imported contexts
import { useUserContext } from "../../../contexts/User.tsx";

// Styled components
const Container = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  // width: clamp(230px, 10vw, 300px);
`;

const Icon = styled.img`
  height: auto;
  margin-right: 8px;
  width: 16px;
`;

// Options for use in side bar nav menu
const sideBarOptions = [
  {
    type: "link",
    label: "Profile Information",
    redirecturl: "/profile/information",
    reqroles: null,
    icon: "Profile",
  },
  {
    type: "link",
    label: "Security Settings",
    redirecturl: "/profile/security",
    reqroles: null,
    icon: "Lock",
  },
  {
    type: "link",
    label: "Administrator Settings",
    redirecturl: "/profile/administrator-settings",
    reqroles: ["Administrator", "Super Administrator"],
    icon: "Settings",
  },
  {
    type: "logout",
    label: "Logout",
    redirecturl: null,
    reqroles: null,
    icon: "Logout",
  },
];

const NavColumn = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { user, userLogout } = useUserContext();

  const handleLogout = async () => {
    await userLogout().then(() => {
      navigate("/login");
    });
  };

  const getIsCurrPath = useCallback(
    (url) => {
      return location.pathname.startsWith(url);
    },
    [location]
  );

  const handleItemClick = (e, option) => {
    e?.preventDefault();

    if (getIsCurrPath(option.redirecturl)) return;

    if (option.type === "link") {
      navigate(option.redirecturl);
    } else if (option.type === "logout") {
      handleLogout();
    }
  };

  return (
    <Container>
      <Box
        sx={{
          bgcolor: "#F2F2F2",
          // border: "1px solid black",
          borderRadius: "8px",
          width: "100%",
        }}
      >
        <nav>
          <List>
            {sideBarOptions
              .filter((option) => {
                if (isNull(option.reqroles)) return true;

                let hasReqRole = false;
                let userRoles = user.roles.map((role) => role.type.codeName);
                for (let i = 0; i < option.reqroles.length; i++) {
                  hasReqRole =
                    hasReqRole || userRoles.includes(option.reqroles[i]);
                  if (hasReqRole) break;
                }

                return hasReqRole;
              })
              .map((option, i) => {
                let isCurrPath = getIsCurrPath(option.redirecturl);

                return (
                  <ListItem
                    className={isCurrPath ? "list-item-curr-path" : null}
                    disablePadding
                    key={`nav-column-option-${i}`}
                    sx={{
                      bgcolor: isCurrPath ? "var(--terbine-blue)" : null,
                      // borderBottom: isCurrPath ? "1px solid black" : null,
                      // borderTop: isCurrPath ? "1px solid black" : null,
                      color: isCurrPath ? "white" : null,
                      cursor: isCurrPath ? "inherit" : "pointer",

                      "&.list-item-curr-path": {
                        color: "white",
                      },

                      "&:hover": {
                        bgcolor:
                          "lab(from var(--terbine-blue) calc(l - 5) a b / 100)",
                        color: "white",
                      },

                      "&:hover svg": {
                        fill: "white",
                      },
                    }}
                  >
                    <ListItemButton
                      onClick={
                        !isCurrPath ? (e) => handleItemClick(e, option) : null
                      }
                      type="button"
                    >
                      {option.icon === "Profile" ? (
                        <ProfileIcon fill={isCurrPath ? "white" : null} />
                      ) : option.icon === "Lock" ? (
                        <LockIcon fill={isCurrPath ? "white" : null} />
                      ) : option.icon === "Logout" ? (
                        <LogoutIcon fill={isCurrPath ? "white" : null} />
                      ) : option.icon === "Settings" ? (
                        <SettingsIcon fill={isCurrPath ? "white" : null} />
                      ) : null}
                      <p
                        style={{
                          fontFamily: "Inter, Oxygen, Roboto, sans-serif",
                          fontSize: "1rem",
                          fontWeight: "400",
                          lineHeight: "2",
                          margin: "0",
                        }}
                      >
                        {option.label}
                      </p>
                    </ListItemButton>
                  </ListItem>
                );
              })}
          </List>
        </nav>
      </Box>
    </Container>
  );
};

export default NavColumn;
